import { useEffect, useState } from 'react';

export const usePageScrollPercentage = () => {
  const [scrollPct, setScrollPct] = useState(0);
  useEffect(() => {
    function handleScroll() {
      const h = document.documentElement;
      const b = document.body;
      const st = 'scrollTop';
      const sh = 'scrollHeight';
      setScrollPct(((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100);
    }
    window.addEventListener('scroll', handleScroll, false);
    return () => window.removeEventListener('scroll', handleScroll, false);
  }, []);
  return scrollPct;
};
